// Opening an invoice's sheet from wherever it's named (a customer's Money tab, Lists): the sheet's host
// (InvoiceSheetHost, mounted once by the app) answers. Kept apart from the sheet, so a page that only
// opens one doesn't load the sheet and its stylesheets.

let opener: ((invoiceId: string) => void) | null = null;

/** Opens the invoice sheet. A no-op until the app has mounted InvoiceSheetHost. */
export function openInvoice(invoiceId: string): void {
  opener?.(invoiceId);
}

/** The host answers openInvoice while it's mounted (null when it goes). */
export function answerOpenInvoice(open: ((invoiceId: string) => void) | null): void {
  opener = open;
}
